import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from 'services/oidcConfig';
import { useAppDispatch } from 'store/hooks';
import { setUser } from 'store/slices/userSlice';
import cls from './auth-page.module.scss';
import { useLazyGetUserInfoQuery } from 'store/api/userApiSlice';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [error, setError] = useState<string | null>(null);
  const [getUserInfo] = useLazyGetUserInfoQuery();

  const exchangeStarted = useRef(false);

  useEffect(() => {
    if (exchangeStarted.current) {
      return;
    }
    exchangeStarted.current = true;

    let isMounted = true;

    const handleAuthCallback = async () => {
      try {
        const user = await userManager.signinRedirectCallback();

        if (!isMounted) return;

        dispatch(
          setUser({
            email: (user.profile.email as string) || null,
            name: (user.profile.name as string) || null,
            sub: user.profile.sub || null,
          })
        );

        const userInfo = await getUserInfo().unwrap();

        if (!isMounted) return;

        if (userInfo?.activeDomains && userInfo.activeDomains.length > 0) {
          navigate('/subscriptions', { state: {} });
        } else {
          navigate('/add-domain');
        }
      } catch (err: any) {
        if (!isMounted) return;

        console.error('Authentication or API process failed:', err);
        setError(err?.message || 'Authentication callback failed');
      }
    };

    handleAuthCallback();

    return () => {
      isMounted = false;
    };
  }, [navigate, dispatch, getUserInfo]);

  return (
    <div className={cls.authPage}>
      <div className={cls.content}>
        <div className={cls.header}>
          {error ? (
            <div>
              <h2>Authentication Error</h2>
              <p style={{ color: '#c00' }}>{error}</p>
              <button onClick={() => navigate('/auth')}>
                Back to Auth Page
              </button>
            </div>
          ) : (
            <h2>Processing login...</h2>
          )}
        </div>
      </div>
      <div className={cls.bg}>
        <div className={cls.blue} />
        <div className={cls.pink} />
        <div className={cls.orange} />
      </div>
    </div>
  );
};
